'use strict';

var browserLogs = require('@datadog/browser-logs');

var allowedStages = ['production', 'staging', 'qa'];

var allowExternalLogging = function allowExternalLogging() {
  return allowedStages.includes(process.env.STAGE);
};

browserLogs.datadogLogs.init({
  clientToken: process.env.DD_CLIENT_TOKEN,
  forwardErrorsToLogs: false,
  env: process.env.STAGE,
  silentMultipleInit: true
});
browserLogs.datadogLogs.logger.setHandler(allowExternalLogging() ? 'http' : 'console');
browserLogs.datadogLogs.logger.setLevel(process.env.LOG_LEVEL || (allowExternalLogging() ? 'error' : 'debug'));
var index = browserLogs.datadogLogs.logger;

module.exports = index;
